module.exports = __webpack_public_path__ + "assets/img/chukong.4925ce22.png";